import { render, staticRenderFns } from "./IconToggle.vue?vue&type=template&id=c0fc19a2&"
import script from "./IconToggle.vue?vue&type=script&lang=ts&"
export * from "./IconToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports